import React, { Component } from "react";
import { connect } from "react-redux";
import { successAlertDispatcher } from "../../redux/actions/alertAction";
import { translate } from "react-i18next";
import { isEmpty } from "lodash";
import { discardShipmentDispatcher, createShipmentDispatcher } from "../../redux/actions/shipmentAction";

import AddTitleBar from "../../components/titleBar/add_titleBar";
import AddOrder from "../../components/newOrderComponent/addOrder";

class NewOrder extends Component {
    constructor(props) {
        super(props);

        this.state = {
        };
    }

    componentDidMount() {
    }

    onFormSubmit = () => {
        this.props.history.push("/shipment");
    };

    render() {
        const { t } = this.props;
        // const { routeCode, routeName} = this.state;
        return (
            <React.Fragment>
                <AddTitleBar
                    Title={this.props.location.pathname == "/new-order" ? (t("create_title") || "Create Shipment") : (t("edit_title") || "Edit Shipment")}
                    LinkName="/new-order"
                />
                <div className="m-2">
                    <AddOrder></AddOrder>
                </div>

            </React.Fragment>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        discardShipment: () => dispatch(discardShipmentDispatcher()),
        createShipment: (shipment) => dispatch(createShipmentDispatcher(shipment, false)),
        successAlert: (alert) => dispatch(successAlertDispatcher(alert)),
    };
};
export default connect(
    null,
    mapDispatchToProps
)(translate("shipment")(NewOrder));
